import styled from 'styled-components';
import * as glx from 'assets/css/glx';

export const BgImg = glx.BgImg;

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const Ul = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Li = styled.li`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-right: 55px;
  }
`;

export const LiIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: block;
`;

export const LiContent = styled.div`
  margin-left: 11px;
`;

export const LiTitle = styled.div`
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 255, 228, 1);
  line-height: 1;
`;

export const LiSubTitle = styled.div`
  line-height: 1;
  margin-top: 7px;

  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 255, 228, 0.7);
`;
